import './src/styles/bootstrap-4.3.1.min.css';

require('prismjs/themes/prism-okaidia.css');

require('prismjs/plugins/line-numbers/prism-line-numbers.css');
